import {
  EntityList,
  EntityListProps,
  renderDate,
  renderEnum,
  renderPath,
} from 'components/EntityList'
import { Proving } from 'gql.generated'
import { ConstrainMode, SelectionMode } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

type ReadProvings_workers = any

export type ProvingListProps = EntityListProps<ReadProvings_workers>

export const AdminResourcesProvingList: React.FunctionComponent<
  ProvingListProps
> = ({ items, ...props }) => {
  const { t } = useTranslation()
  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
  const columns = React.useMemo(
    () => [
      fieldColumn('status', {
        onRender: renderEnum(t, 'status'),
        getGroupValue: (item: Proving) => t(`enum.status.${item.status}`),
        minWidth: 70,
        maxWidth: 90,
        ungroupable: true,
      }),
      fieldColumn('dateFrom', {
        onRender: renderDate,
        isSorted: true,

        ungroupable: true,
      }),
      fieldColumn('dateTo', {
        onRender: renderDate,
        ungroupable: true,
      }),
      fieldColumn('id', { ungroupable: true }),
      fieldColumn('title', {
        ungroupable: true,
      }),
      fieldColumn('provingGround.title', {
        onRender: renderPath,
        getGroupValue: (item: Proving) => item.provingGround!.title,
        ungroupable: true,
      }),
    ],
    [fieldColumn, t]
  )

  return (
    <EntityList
      alternate={true}
      selectionMode={SelectionMode.multiple}
      items={items}
      constrainMode={ConstrainMode.horizontalConstrained}
      columns={columns}
      stickyHeader={true}
      {...props}
    />
  )
}
